var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingCart10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4062 5.89189V7.51351H10.125C9.50368 7.51351 9 7.99753 9 8.59459V12.9189C9 13.516 9.50368 14 10.125 14H16.875C17.4963 14 18 13.516 18 12.9189V8.59459C18 7.99753 17.4963 7.51351 16.875 7.51351H16.5937V5.89189C16.5937 4.84703 15.7123 4 14.625 4H12.375C11.2877 4 10.4062 4.84703 10.4062 5.89189ZM12.375 5.62162H14.625C14.7803 5.62162 14.9062 5.74263 14.9062 5.89189V7.51351H12.0937V5.89189C12.0937 5.74263 12.2197 5.62162 12.375 5.62162Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23716 4.28851C1.8442 4.15752 1.41946 4.36989 1.28848 4.76285C1.15749 5.15581 1.36986 5.58055 1.76282 5.71153L3.66173 6.3445C4.08729 6.48635 4.4042 6.84535 4.49218 7.28521L5.943 14.5393C6.20008 15.8247 7.32872 16.75 8.6396 16.75H18.4914C19.7192 16.75 20.7983 15.9361 21.1356 14.7555L22.7211 9.20606C22.8349 8.80778 22.6043 8.39267 22.206 8.27888C21.8078 8.16508 21.3926 8.3957 21.2788 8.79398L19.6933 14.3434C19.54 14.88 19.0495 15.25 18.4914 15.25H8.6396C8.04375 15.25 7.53073 14.8294 7.41387 14.2451L5.96305 6.99104C5.76951 6.02335 5.07229 5.23355 4.13608 4.92148L2.23716 4.28851Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 21C10.3284 21 11 20.3284 11 19.5C11 18.6716 10.3284 18 9.5 18C8.67157 18 8 18.6716 8 19.5C8 20.3284 8.67157 21 9.5 21Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.5C19 20.3284 18.3284 21 17.5 21C16.6716 21 16 20.3284 16 19.5C16 18.6716 16.6716 18 17.5 18C18.3284 18 19 18.6716 19 19.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart10);
export default __webpack_public_path__ + "static/media/shopping-cart-10.b04f272edefac9e137af08b65026702c.svg";
export { ForwardRef as ReactComponent };